import { WorkspaceServerService } from '@affine/core/modules/cloud';
import {
  WorkspaceScope,
  WorkspaceService,
} from '@affine/core/modules/workspace';
import { type Framework } from '@toeverything/infra';

import { EmbeddingEnabled } from './entities/embedding-enabled';
import { EmbeddingProgress } from './entities/embedding-progress';
import { IgnoredDocs } from './entities/ignored-docs';
import { EmbeddingService } from './services/embedding';
import { EmbeddingStore } from './stores/embedding';

export function configureIndexerEmbeddingModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .store(EmbeddingStore, [WorkspaceServerService])
    .service(EmbeddingService, [WorkspaceService, EmbeddingStore])
    .entity(EmbeddingEnabled, [WorkspaceService, EmbeddingStore])
    .entity(IgnoredDocs, [WorkspaceService, EmbeddingStore])
    .entity(EmbeddingProgress, [WorkspaceService, EmbeddingStore]);
}

export { EmbeddingService } from './services/embedding';
export { EmbeddingSettings, useEmbeddingAvailable } from './view';
